import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["backgroundColor", "textColor", "children"];
import { mediaQuery, css, theme } from 'academy-common-lib/utils/Styling';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSection = styled.section.withConfig({
  displayName: "StyledSection",
  componentId: "espfpy-0"
})(["padding-block:60px;", ""], mediaQuery('notMobile', css(["padding-block:120px;"])));
const StyledSectionComponent = _ref => {
  let {
      backgroundColor,
      textColor,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledSection, Object.assign({
    style: {
      backgroundColor: backgroundColor || theme.colors.OLAF,
      color: textColor || null
    }
  }, rest, {
    children: children
  }));
};
export default StyledSectionComponent;